import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getPasswordStrength } from "../../../utils/validators";



export function PasswordStrengthMeter({
  passwordStrength=0,
}) {
  const [label, setLabel] = useState("");

  useEffect(() => {
    const passwordStrengthLabel = getPasswordStrength(passwordStrength);

    setLabel(passwordStrengthLabel);
  }, [passwordStrength]);


  return (
    <>
      <div className="u--padding-bottom u__bold">
        {`Strength: ${label}`}
      </div>
      <div className="strength-meter">
        <div className={`strength-meter-bar ${label.toLowerCase()}`}  />
      </div>
    </>
  );
}

PasswordStrengthMeter.propTypes = {
  passwordStrength: PropTypes.number.isRequired
}

export default PasswordStrengthMeter;